import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2L2 22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12L2 22h10V12z"
})), 'SignalCellular1BarTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellular1BarTwoTone.js
// module id = 6142
// module chunks = 2